import React from "react";
import {Button, Card, CardContent, Grid} from "@material-ui/core";
import style from "./RoleAccess.module.scss";
import {fontSize13} from "../../utils/Css";
import {Redirect} from "react-router-dom";

class RoleAccess extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      redirectDashboard: false,
      datauserHardcode: [
        "Admin Sicepat",
        "Admin COD - Merger",
        "Admin GA",
        "Asset Management Staff",
        "Asisstant Manager General Affair",
        "Asset Management Supervisor",
        "Audit Internal",
        "Billing & Collection - Payment Admin",
        "Billing Admin",
        "Consumable Management Staff",
        "Consumable Management Supervisor",
        "Control Tower",
        "CT Return",
        "CS Monitoring",
        "CS CKL",
        "Control Tower Denda",
        "GA - Staff Warehouse",
        "GA - Warehouse Staff",
        "HRD - Payroll",
        "HC Monitoring",
        "Industrial Engineer Manager",
        "IT Support Pusat",
        "IT Support Cabang",
        "IT support Create User",
        "Koordinator HUB",
        "Koordinator Hub",
        "Monitoring Operasional",
        "Marketing",
        "Ops - Admin COD",
        "Ops - Admin Hub",
        "Ops - Admin Bagging Transit",
        "Ops - Admin Malam",
        "Ops - Admin Operational ( COD )",
        "Ops - Admin Ops COD",
        "Ops - Admin COD",
        "Ops - Admin SMD",
        "ops - admin operational",
        "Ops - Admin Pengantaran",
        "Ops - Admin Luar Kota",
        "Ops - Admin Toko",
        "Ops - Admin.NEW",
        "Ops - Admin New",
        "Ops - Admin Mobile",
        "Ops - Admin Retur",
        "Ops - Admin SDS",
        "OPS - Admin Warehouse",
        "Ops - Bagging",
        "Ops - Customer Service",
        "Ops - Customer Service 1",
        "OPS - Claim",
        "Ops - COO",
        "Ops - Checker",
        "Ops - CS Mobile",
        "Ops - CT Line Haul",
        "Ops - Collection",
        "Ops - Driver Bandara",
        "Ops - Driver pickup",
        "Ops - Data Entry",
        "Ops - Driver",
        "Ops - Driver SMD",
        "Ops - Driver SDS",
        "Ops - First Mile Driver SDS",
        "Ops - First Mile Sigesit Pick Up",
        "Ops - First Mile Koordinator Pick Up",
        "Ops - First Mile Koordinator SDS",
        "Ops - First Mile Sigesit SDS",
        "Ops - First Mile Assitant Koordinator SDS",
        "Ops - First Mile Koordinator Sigesit Pick Up",
        "Ops - First Mile Koordinator Wilayah",
        "Ops - Helper",
        "Ops - Koordinator Operational",
        "Ops - Kepala Sigesit",
        "Ops - Kepala SMU",
        "Ops - Kepala Kurir SDS First Mile",
        "Ops - Kepala Kurir SDS Last Mile",
        "Ops - Koordinator Regional",
        "Ops - Koordinator Cabang",
        "OPS - Kordinator Line-Haul",
        "Ops - Koordinator Checker ",
        "Ops - Koordinator Checker",
        "Ops - Kepala Sorter",
        "OPS - Koordinator Toko / Drop Point",
        "Ops - Koordinator Sigesit Pick UP",
        "Ops - Koordinator wilayah HRD",
        "Ops - Last Mile Assitant Koordinator Sigesit",
        "Ops - Last Mile Driver",
        "Ops - Last Mile Driver SDS",
        "Ops - Last Mile Koordinator Sigesit (COD)",
        "Ops - Last Mile Assistant Koordinator ( COD )",
        "Ops - Last Mile Sigesit",
        "Ops - Last Mile Koordinator Wilayah",
        "Ops - Last Mile Koordinator Sigesit",
        "Ops - Last Mile Sigesit Transit",
        "Ops - Last Mile Koordinator SDS",
        "Ops - Last Mile Sigesit SDS",
        "Ops - Last Mile Assitant Koordinator SDS",
        "Ops - Last Mile Assitant Koordinator Sigesit New",
        "Ops - Last Mile Koordinator Sigesit New",
        "Ops - Last Mile Sorter New",
        "Ops - Laporan SMU",
        "OPS - Laporan Koordinator Malam",
        "Ops - Monitoring PickUp",
        "Ops - Return Staff",
        "Ops - SMD Dalam Kota",
        "Ops - Sorter Gerai",
        "OPS DARAT MP",
        "OPS - Sorter Pickup",
        "Ops - Sorter",
        "Ops - Operator SMU",
        "Ops - Sigesit pick UP",
        "Operatinal - Kepala SMU",
        "Operator SMU",
        "Root Cost Control",
        "Root HRD",
        "Root HRD Master Data",
        "Root CT",
        "Root IT",
        "ROOT IT COD",
        "Root Cost Control",
        "Root Procurement",
        "Root Sales Marketing",
        "Root Business Process",
        "Root Business Analyst",
        "SMD Dalam Kota",
        "Sales",
        "Sales - Key Account Officer",
        "sales monitoring",
        "Senior Manager General Affair",
        "Senior Checker",
        "Superadmin",
      ],
    };
  }

  handleOnclick = (data) => {
    const userData = localStorage.getItem("userData")
      ? JSON.parse(localStorage.userData)
      : null;
    // userData.map((d) => {
    //   console.log(d);
    // });
    userData.role_name = data.roleName;
    
    localStorage.setItem("userData", JSON.stringify(userData));
    localStorage.setItem("branchCode", data.branchCode);
    this.setState({redirectDashboard: true});
  };
  logout() {
    localStorage.setItem("userData", "");
    localStorage.setItem("branchCode", "");

    localStorage.clear();
    this.setState({redirect: true});
  }

  render() {
    const userData = localStorage.getItem("userData")
      ? JSON.parse(localStorage.userData)
      : null;
    if (userData === null) {
      return <Redirect to={"/"} />;
    }
    if (this.state.redirect) {
      return <Redirect to={"/"} />;
    }
    if (
      this.state.redirectDashboard ||
      (userData && typeof userData.role_name === "string")
    ) {
      return <Redirect to={"/admin/dashboard"} />;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <Card
          style={{
            minWidth: 600,
            margin: "10em",
            padding: "50px 25px",
            borderRadius: "13px",
            boxShadow: "0px 0px 30px 0px #565656",
          }}
        >
          <Button
            variant='contained'
            color='primary'
            style={{
              float: "right",
              width: "20%",
              height: "35px",
              fontSize: "13px",
            }}
            onClick={(e) => {
              this.logout();
            }}
          >
            Keluar
          </Button>
          <CardContent>
            <Grid
              container
              direction='row'
              justify='center'
              alignItems='center'
            >
              <div
                style={{
                  fontSize: "23px",
                  textAlign: "center",
                  paddingBottom: "16px",
                  paddingTop: "16px",
                }}
              >
                Pilih Akses Anda
              </div>
            </Grid>
            <Grid>
              <div
                style={{
                  maxHeight: "500px",
                  overflowY: "auto",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                  overflowX: "hidden",
                }}
              >
                {userData.role_name.map((data, index) => {
                  for (let i = 0; i < this.state.datauserHardcode.length; i++) {
                    if (data.roleName === this.state.datauserHardcode[i]) {
                      return (
                        <div
                          style={{
                            borderBottom: "1px solid #cccccc",
                            padding: "10px 0px 10px 0px",
                          }}
                        >
                          <Grid container spacing={8}>
                            <Grid item xs={9}>
                              {data.value}
                            </Grid>
                            <Grid item xs={3}>
                              <Button
                                variant='contained'
                                color='secondary'
                                style={{
                                  float: "right",
                                  width: "20%",
                                  height: "35px",
                                  fontSize: "13px",
                                }}
                                onClick={(e) => {
                                  this.handleOnclick(data);
                                }}
                              >
                                Masuk
                              </Button>
                            </Grid>
                          </Grid>
                        </div>
                      );
                    }
                  }
                })}
              </div>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default RoleAccess;
